<template>
  <div @click.stop>
    <button v-if="isAdding"
            type="button"
            ref="btnEl"
            class="bg-transparent border-0 cursor-pointer p-3 rounded-lg hover:bg-primary-light flex items-center gap-1 text-focus-error"
            @click="handleAddSource"
    >
      <span>Cancel</span>
      <CloseIcon class="h-4 w-4"/>
    </button>

    <base-dropdown v-else
                   :dropdown-position="dropdownPosition"
                   use-teleport
    >
      <template #trigger="{ mousedownHandler, blurHandler, focusHandler, keydownHandler }">
        <button type="button"
                ref="btnEl"
                class="bg-transparent border-0 cursor-pointer p-3 rounded-lg hover:bg-primary-light flex items-center gap-1 text-gray-dark"
                @mousedown="mousedownHandler"
                @focus="focusHandler"
                @blur="handleTriggerBlur($event, blurHandler)"
                @keydown="keydownHandler"
        >
          + Add source
        </button>
      </template>

      <template #default="{ blurHandler, hide }">
        <base-button v-for="(option, i) in options"
                     :key="option.title"
                     variant="dropdown-no-description"
                     class="pr-4 pl-4 py-3 transition duration-150 ease-in-out"
                     :class="i === hoveredButtonIndex ? 'text-primary-focus' : 'text-gray'"
                     role="menuitem"
                     @blur="blurHandler"
                     @click.prevent="selectOption(i, hide)"
                     @mouseenter.native="hoveredButtonIndex = i"
                     @mouseleave.native="hoveredButtonIndex = null"
        >
          <div class="flex mb-1 items-end flex-row-reverse">
            <div class="font-bold clamp" :title="option.title" v-html="option.label || option.title"/>
            <component v-if="option.icon"
                       :is="option.icon.tag"
                       :icon="option.icon.identifier"
                       :src="option.icon.identifier"
                       size="1.3rem"
                       class="ml-1"
            />
          </div>
        </base-button>
      </template>
    </base-dropdown>
  </div>
</template>

<script>
import BaseDropdown from '@/components/base-components/BaseDropdown.vue'
import BaseButton from '@/components/base-components/BaseButton'
import CloseIcon from '@/assets/images/icons/CloseIcon.vue'
import dropdownButtonsUtils from '@/utils/dropdown-button.utils'
import { DROPDOWN_LOCATIONS } from '@/utils/dropdown-button.constants'
import is from 'ramda/src/is'

export default {
  name: 'SettingsIndexesAddSourceButton',

  components: {
    CloseIcon,
    BaseDropdown,
    BaseButton
  },

  props: {
    isAdding: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      dropdownPosition: DROPDOWN_LOCATIONS.BELOW_RIGHT,
      hoveredButtonIndex: null
    }
  },

  computed: {
    options() {
      return dropdownButtonsUtils.getAddKBSourceOptions()
    }
  },

  methods: {
    handleTriggerBlur(event, blurHandler) {
      if (event.relatedTarget?.role === 'menuitem') return
      blurHandler(event)
    },
    handleAddSource(optIndex) {
      const sourceType = is(Number, optIndex) ? this.options[optIndex].key : null
      const el = this.$refs.btnEl
      this.$emit('add-source', { sourceType, el })
    },
    selectOption(optionIndex, hide) {
      hide()
      this.hoveredButtonIndex = null
      this.handleAddSource(optionIndex)
    }
  }
}
</script>
